import type { QuoteFreightLeg } from './quote-freight.types';
import type { QuoteLineItem } from './quote.types';

export type ProrationMethod = 'WEIGHT' | 'VOLUME' | 'FOB_VALUE' | 'UNITS' | 'EQUAL';

export interface QuoteShipmentLineItem extends QuoteLineItem {
  proratedFreightCost?: number;
  shipmentId?: string | null;
}

export interface QuoteShipment {
  id: string;
  quoteId: string;
  name: string;
  origin?: string | null;
  incoterm?: string | null;
  prorationMethod: ProrationMethod;
  notes?: string | null;
  totalCost: number;
  // Overrides manuales del envío: si están seteados (>0), reemplazan
  // la derivación automática de peso/volumen/FOB desde las líneas.
  manualWeight?: number | null;
  manualVolume?: number | null;
  manualFob?: number | null;
  legs: QuoteFreightLeg[];
  lineItems: QuoteShipmentLineItem[];
}

export interface CreateQuoteShipmentData {
  name: string;
  origin?: string;
  incoterm?: string;
  prorationMethod?: ProrationMethod;
  notes?: string;
}

export interface UpdateQuoteShipmentData extends Partial<CreateQuoteShipmentData> {
  manualWeight?: number | null;
  manualVolume?: number | null;
  manualFob?: number | null;
}

export const PRORATION_METHOD_LABELS: Record<ProrationMethod, string> = {
  WEIGHT: 'Por Peso',
  VOLUME: 'Por Volumen',
  FOB_VALUE: 'Por Valor FOB',
  UNITS: 'Por Unidades',
  EQUAL: 'Partes Iguales',
};

export const PRORATION_METHODS: ProrationMethod[] = [
  'WEIGHT',
  'VOLUME',
  'FOB_VALUE',
  'UNITS',
  'EQUAL',
];
